import React, { Component } from 'react';
import './style.scss';
import { connect } from 'react-redux';
import {setRiskGrades} from '../action';
//import './style.css';

class RiskGrades extends Component {
    constructor(props) {
        super(props);
        this.state = {
            riskGrades: [{
                minScore: '',
                maxScore: '',
                riskGrade: '',
                gradeDescription: '',
                pd: ''
            }]
        };
    }

    handleChange = (evt) => {
        let index = evt.target.id.split('-')[1];
        let key = evt.target.name;
        const tempRiskGrades = this.state.riskGrades.slice();
        tempRiskGrades[index][key] = evt.target.value;
        this.setState({
            riskGrades: tempRiskGrades
        })
        this.props.setRiskGardes(this.state.riskGrades);
    }

    componentDidMount() {
             this.setState({
                 riskGrades: [{ minScore: '', maxScore: '', riskGrade: '', gradeDescription: '', pd: '' }],
             });
        
    } 
    componentDidUpdate(previousProps) {
        if (this.props.riskGrades) {
            if (previousProps.riskGrades !== this.props.riskGrades) {
                this.setState({
                    riskGrades: this.props.riskGrades
                })
            }
        }
    }
    handleAddRows=(e)=>{
        e.preventDefault();
        this.setState((prevState) => ({
            riskGrades: [...prevState.riskGrades, { minScore: '', maxScore: '', riskGrade: '', gradeDescription: '', pd: '' }],
        }));
    }
    handleDeleteRows=()=>{
          let rows=this.state.riskGrades;
          rows.pop()
          this.setState({
            riskGrades:[...rows]
          }
              
          )
    }

    render() {
        
        return (
            <div>
                <table className="table table-bordered">
                    <thead className="header-blue">
                        <tr>
                            <th>
                                Score-Min
                            </th>
                            <th>
                                Score-Max
                            </th>
                            <th>
                                Grade Name
                            </th>
                            <th>
                                Grade Description
                            </th>
                            <th>
                                PD
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                    {
                        this.state.riskGrades.map((risk, id) => {
                            let minId = `min-${id}`, maxId = `max-${id}`, gradeNameId = `gradeName-${id}`, gradeDescId = `gradeDesc-${id}`, pdId = `pd-${id}`;
                            return (
                                <tr key = {id}>
                                    <td>
                                        <input
                                        type="number"
                                        onChange={(event) => this.handleChange(event)}
                                        className="form-control"
                                        value={risk.minScore}
                                        name="minScore"
                                        id={minId} autoComplete="on" />
                                    </td>
                                    <td>
                                        <input
                                        type="number"
                                        onChange={(event) => this.handleChange(event)}
                                        className="form-control"
                                        value={risk.maxScore}
                                        name="maxScore"
                                        id={maxId} autoComplete="on" />
                                    </td>
                                    <td>
                                        <input
                                        type="text"
                                        onChange={(event) => this.handleChange(event)}
                                        className="form-control"
                                        value={risk.riskGrade}
                                        name="riskGrade"
                                        id={gradeNameId} autoComplete="on" />
                                    </td>
                                    <td>
                                        <input
                                        type="text"
                                        onChange={(event) => this.handleChange(event)}
                                        className="form-control"
                                        value={risk.gradeDescription}
                                        name="gradeDescription"
                                        id={gradeDescId} autoComplete="on" />
                                    </td>
                                    <td>
                                        <input
                                        type="text"
                                        onChange={(event) => this.handleChange(event)}
                                        className="form-control"
                                        value={risk.pd}
                                        name="pd"
                                        id={pdId} autoComplete="on" />
                                    </td>
                                </tr>
                            );
                        })
                    }
                    </tbody>
                </table>
                <div>
                    <button type="button" className="btn btn-icon btn-outline-primary" title="Add Rows"
                            onClick={this.handleAddRows}><i className="icon-plus v-align-middle"></i></button>
                    <button type="button" className="btn btn-icon btn-outline-primary ml-4" title="Remove Rows"
                            onClick={this.handleDeleteRows}><i className="icon-minus v-align-middle"></i></button>
                </div>
            </div>
            
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    id: ownProps.id,
    searchResults: state.autoSuggest.searchResults,
    searchKey: state.autoSuggest.searchKey,
    riskGrades: state.riskGrades.riskGrades
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    setRiskGardes: (risk) => dispatch(setRiskGrades(risk)),
});
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RiskGrades);
